import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  margin-bottom: 20px;
`;

export const ContentTitle = styled.div`
  width: 184px;
  height: 36px;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #0d6efd;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ececec;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 16px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-size: 14px;
  text-align: start;
`;

export const ContentBody = styled.div`
  padding: 16px 0 0 0;
`;

export const Row = styled.div`
  display: flex;
  gap: 32px;
  align-items: flex-end;
`;

export const Column = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const Button = styled.button`
  font-family: Inter;
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-width: 227px;
  padding: 10px;
  background-color: #0d6efd;
  border-radius: 8px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
